import LeadActivityModule from "./LeadActivityModule";
import reducer from "./redux/leadActivityReducer";
import saga from "./redux/leadActivitySagas";

export default {
  Component: LeadActivityModule,
  moduleName: "leadActivity",
  saga: saga(),
  reducer: reducer
};
